__turbopack_context__.v({
  "box": "radio-module-scss-module__Yn0EbW__box",
  "checked-icon": "radio-module-scss-module__Yn0EbW__checked-icon",
  "disabled": "radio-module-scss-module__Yn0EbW__disabled",
  "input": "radio-module-scss-module__Yn0EbW__input",
  "label": "radio-module-scss-module__Yn0EbW__label",
  "primary": "radio-module-scss-module__Yn0EbW__primary",
  "radio": "radio-module-scss-module__Yn0EbW__radio",
  "ripple": "radio-module-scss-module__Yn0EbW__ripple",
  "secondary": "radio-module-scss-module__Yn0EbW__secondary",
  "un-checked-icon": "radio-module-scss-module__Yn0EbW__un-checked-icon",
});
